import { useEffect, useRef, useState } from "react";

import { startLessonAttempt } from "../api/learnApi";

interface UseLessonAttemptParams {
    enabled: boolean;
    userId?: number | string;
    sessionId?: string;
    contentId: string;
}

// Creates a lesson attempt once, when a lesson opens.
// Returns the new attempt id, plus loading and error flags.
export const useLessonAttempt = ({ enabled, userId, sessionId, contentId }: UseLessonAttemptParams) => {
    const [lessonAttemptId, setLessonAttemptId] = useState<number | string | null>(null);
    const [starting, setStarting] = useState(false);
    const [startError, setStartError] = useState(false);

    // Remembers which content already got an attempt. A ref (not state) so that
    // React StrictMode's double-run of effects can't create two attempts.
    const startedFor = useRef<string | null>(null);

    useEffect(() => {
        if (!enabled || userId === undefined || startedFor.current === contentId) return;

        startedFor.current = contentId;
        setLessonAttemptId(null);
        setStartError(false);
        setStarting(true);

        startLessonAttempt(userId, { session_id: sessionId, content_id: contentId })
            .then(setLessonAttemptId)
            .catch((err) => {
                console.error("Starting the lesson attempt failed:", err);
                setStartError(true);
            })
            .finally(() => setStarting(false));
    }, [enabled, userId, sessionId, contentId]);

    return { lessonAttemptId, starting, startError };
};